import './reportUsageLog.scss';

import React, { Fragment } from 'react';
import moment from 'moment';
import Loader from 'react-loaders';
import { Col, Row, Switch, } from 'react-materialize';

import {
    CATEGORY_LIST_OPTIONS,
    DATE_FORMAT,
    FORM_OPERATIONS,
    REPORT_FORMAT,
    USAGE_LOG_LABELS,
    USAGE_LOG_PROPERTIES,
} from '../../../constants/appConstants';
import { populateCsvHeader } from '../../../utils/csv.utility';
import dateUtil from '../../../utils/dateUtil';
import { dynamicSort } from '../../../utils/objectUtil';
import { TatvamButton, TatvamCol, TatvamDatePicker, TatvamGrid, TatvamMultiSelect, } from '../../functionalComponents';
import CsvExport from '../../functionalComponents/csvExport/csvExport';
import AlertBox from '../alertBox';

class ReportUsageLogs extends React.Component {
    constructor(props) {
        super(props);
        const customComparator = (valueA, valueB) => {
            return String(valueA).toLowerCase().localeCompare(String(valueB).toLowerCase());
        };
        const dateComparator = (date1, date2) => {
            return new Date(String(date1)) < new Date(String(date2)) ? -1 : 1;
        };
        const dateFilter = (filterLocalDateAtMidnight, cellValue) => {
            if (cellValue === null || cellValue === 0) return -1;
            let cellDate = new Date(String(cellValue).slice(0, 11));
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
        };
        this.state = {
            colDef: [
                {
                    headerName: USAGE_LOG_LABELS.APPLICATION, field: USAGE_LOG_PROPERTIES.APPLICATION_DISPLAY_NAME,
                    comparator: customComparator,
                    filterParams: { clearButton: true },
                    width: 150,
                    suppressSizeToFit: true,
                },
                {
                    headerName: USAGE_LOG_LABELS.REPORT_NAME, field: USAGE_LOG_PROPERTIES.REPORT_NAME,
                    comparator: customComparator,
                    filterParams: { clearButton: true },
                    width: 230,
                    suppressSizeToFit: true,
                },
                {
                    headerName: USAGE_LOG_LABELS.REPORT_USED_FIRST, field: USAGE_LOG_PROPERTIES.REPORT_USED_FIRST,
                    comparator: dateComparator,
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: dateFilter,
                        clearButton: true
                    },
                    cellStyle: () => ({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }),
                    valueFormatter: params => params.value === 0 ? '--' : params.value,
                    width: 180,
                    suppressSizeToFit: true
                },
                {
                    headerName: USAGE_LOG_LABELS.REPORT_USED_LAST, field: USAGE_LOG_PROPERTIES.REPORT_USED_LAST,
                    comparator: dateComparator,
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: dateFilter,
                        clearButton: true
                    },
                    cellStyle: () => ({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }),
                    valueFormatter: params => params.value === 0 ? '--' : params.value,
                    width: 180,
                    suppressSizeToFit: true
                },
                {
                    headerName: USAGE_LOG_LABELS.ACTUAL_LAST_LOGIN, field: USAGE_LOG_PROPERTIES.ACTUAL_LAST_LOGIN,
                    comparator: dateComparator,
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: dateFilter,
                        clearButton: true
                    },
                    width: 180,
                    suppressSizeToFit: true,
                    cellStyle: () => ({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }),
                    valueFormatter: params => params.value === 0 ? '--' : params.value
                },
                {
                    headerName: USAGE_LOG_LABELS.TOTAL_USED, field: USAGE_LOG_PROPERTIES.NO_TIMES_USED,
                    filterParams: { clearButton: true },
                    filter: "agNumberColumnFilter",
                    cellStyle: () => ({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }),
                    valueFormatter: params => params.value === 0 ? '--' : params.value,
                    width: 140,
                    suppressSizeToFit: true
                },
                {
                    headerName: USAGE_LOG_LABELS.AVG_TIMES_BTN_LOGINS, field: USAGE_LOG_PROPERTIES.AVG_TIMES_BTN_LOGINS,
                    filterParams: { clearButton: true },
                    filter: "agNumberColumnFilter",
                    cellStyle: () => ({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }),
                    valueFormatter: params => params.value === 0 ? "NA" : params.value,
                    width: 180,
                    suppressSizeToFit: true,
                },
            ],
            exportColumns: [
                {
                    label: USAGE_LOG_LABELS.APPLICATION,
                    key: USAGE_LOG_PROPERTIES.APPLICATION_DISPLAY_NAME
                },
                {
                    label: USAGE_LOG_LABELS.REPORT_NAME,
                    key: USAGE_LOG_PROPERTIES.REPORT_NAME
                },
                {
                    label: USAGE_LOG_LABELS.REPORT_USED_FIRST,
                    key: USAGE_LOG_PROPERTIES.REPORT_USED_FIRST
                },
                {
                    label: USAGE_LOG_LABELS.REPORT_USED_LAST,
                    key: USAGE_LOG_PROPERTIES.REPORT_USED_LAST
                },
                {
                    label: USAGE_LOG_LABELS.ACTUAL_LAST_LOGIN,
                    key: USAGE_LOG_PROPERTIES.ACTUAL_LAST_LOGIN
                },
                {
                    label: USAGE_LOG_LABELS.TOTAL_USED,
                    key: USAGE_LOG_PROPERTIES.NO_TIMES_USED
                },
                {
                    label: USAGE_LOG_LABELS.AVG_TIMES_BTN_LOGINS,
                    key: USAGE_LOG_PROPERTIES.AVG_TIMES_BTN_LOGINS
                },
            ],
            gridData: [],
            exportData: [],
            applicationListOptions: [],
            categoryListOption: CATEGORY_LIST_OPTIONS,
            endDate: new Date(),
            startDate: dateUtil.substractDate(30),
            selectedApplication: [],
            selectedCategory: CATEGORY_LIST_OPTIONS,
            preLoader: true,
            is_include_internal_users: false,
            is_include_inactive_customers: false,
            isAlertBoxOpen: false,
            editFlag: false,
            isFormValid: true
        };
    }

    handleCategoryChange = categories => {
        this.setState({
            selectedCategory: categories,
            editFlag: true,
            isFormValid: true
        });
    }

    handleApplicationChange = application => {
        this.setState({
            selectedApplication: application,
            editFlag: true,
            isFormValid: true
        });
    }

    handleStartDate = date => {
        this.setState({
            startDate: date,
            editFlag: true
        });
    };

    handleEndDate = date => {
        this.setState({
            endDate: date,
            editFlag: true
        });
    }

    handleToggleChange = e => {
        if (e.target.id === USAGE_LOG_PROPERTIES.IS_INCLUDE_INTERNAL_USERS) {
            this.setState({
                is_include_internal_users: e.target.checked,
                editFlag: true
            });
        }

        if (e.target.id === USAGE_LOG_PROPERTIES.IS_INCLUDE_INACTIVE_CUSTOMERS) {
            this.setState({
                is_include_inactive_customers: e.target.checked,
                editFlag: true
            });
        }
    }

    isValidForm = () => {
        const { selectedCategory, selectedApplication } = this.state;
        if ((selectedCategory && selectedCategory.length > 0) && (selectedApplication != null && selectedApplication.length > 0)) {
            this.setState({
                isFormValid: true
            });
            return true;
        } else {
            this.setState({
                isFormValid: false
            });
            return false;
        }
    };

    handleSave = e => {
        e.preventDefault();

        let formValid = this.isValidForm();
        if (formValid) {
            this.setState({
                preLoader: true
            });

            const payload = this.generatePayload();

            this.props.actions.getReportsUsageLogDetails(payload).then((response) => {
                const modifiedExportData = this.modifyExportData(response.data.data);

                if (response.status !== 200 && response.status !== 204) {
                    this.setState({
                        preLoader: false,
                        shouldCloseModal: false,
                        isAlertBoxOpen: true,
                        isConfirmBox: false,
                        isSuccess: false,
                        alert_information: response.data ? response.data.message : response.message
                    });
                } else if (response.status === 200) {
                    this.setState({
                        editFlag: false,
                        gridData: response.data.data.sort((dynamicSort(USAGE_LOG_PROPERTIES.FIRST_NAME))),
                        exportData: modifiedExportData.sort((dynamicSort(USAGE_LOG_PROPERTIES.FIRST_NAME))),
                        preLoader: false,
                    });
                } else {
                    this.setState({
                        editFlag: false,
                        gridData: [],
                        exportData: [],
                        preLoader: false
                    });
                }
            });
        }
    }

    generatePayload = () => {
        const payload = { categories: [], log_source: [] };

        this.state.selectedApplication.forEach((oneApplication) => {
            payload.log_source.push(oneApplication.value);
        });

        this.state.selectedCategory.forEach((oneCategory) => {
            payload.categories.push(oneCategory.value);
        });

        if (this.state.is_include_internal_users) {
            payload.internal_users = this.state.is_include_internal_users;
        }
        if (this.state.is_include_inactive_customers) {
            payload.inactive_customer = this.state.is_include_inactive_customers;
        }

        payload.start_date = moment(this.state.startDate).format(DATE_FORMAT.YYYYMMDD);
        payload.end_date = moment(this.state.endDate).format(DATE_FORMAT.YYYYMMDD);
        return payload;
    }

    alterDiscard = (data) => {
        this.setState({
            isConfirmBox: false,
            isAlertBoxOpen: false,
            isSuccess: false
        });
    };

    loadApplicationDropDown = (thisProps) => {
        if (thisProps.applicationList) {
            const applicationList = [];

            thisProps.applicationList.forEach((appName) => {
                applicationList.push({ label: appName.display_name, value: appName.name });
            });
            applicationList.sort(dynamicSort("label"));

            this.setState({
                applicationListOptions: applicationList,
                selectedApplication: applicationList
            });
        }
    };

    componentDidMount() {
        this.props.actions.fetchApplicationNames().then(() => {
            this.loadApplicationDropDown(this.props);
        });

        const payload = {
            start_date: moment(this.state.startDate).format(DATE_FORMAT.YYYYMMDD),
            end_date: moment(this.state.endDate).format(DATE_FORMAT.YYYYMMDD),
            categories: []
        };

        this.state.selectedCategory.forEach((oneCategory) => {
            payload.categories.push(oneCategory.value);
        });

        this.props.actions.getReportsUsageLogDetails(payload).then((response) => {
            const modifiedExportData = this.modifyExportData(response.data.data);

            if (response.status !== 200 && response.status !== 204) {
                this.setState({
                    preLoader: false,
                    editFlag: true,
                    shouldCloseModal: false,
                    isAlertBoxOpen: true,
                    isConfirmBox: false,
                    isSuccess: false,
                    alert_information: response.data ? response.data.message : response.message
                });
            } else if (response.status === 200) {
                this.setState({
                    gridData: response.data.data.sort((dynamicSort(USAGE_LOG_PROPERTIES.CUSTOMER_NAME))),
                    exportData: modifiedExportData.sort((dynamicSort(USAGE_LOG_PROPERTIES.FIRST_NAME))),
                    preLoader: false
                });
            } else {
                this.setState({
                    gridData: [],
                    exportData: [],
                    preLoader: false
                });
            }
        });
    }

    modifyExportData = (data) => {
        let modifiedData = [];
        if (data) {
            data.forEach((ele) => {
                const oneObject = { ...ele };
                for (var i in oneObject) {
                    if (oneObject[i] === 0) {
                        oneObject[i] = "";
                    }
                }
                modifiedData.push(oneObject);
            });
        }
        return modifiedData;
    }

    handleDownloadHTML = () => {
        let payload = this.generatePayload();
        payload.report_format = REPORT_FORMAT.HTML;

        this.setState({
            preLoader: true
        });
        
        this.props.actions.getReportsUsageLogDetails(payload).then((response) => {
            if (response.status !== 200 && response.status !== 204) {
                this.setState({
                    alert_information: "Error while generating the HTML files.",
                    preLoader: false
                });
            } else if (response.status === 200) {
                const htmlContent = response.data;

                const blob = new Blob([htmlContent], { type: 'text/html' });

                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = 'ReportsUsage.html';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                URL.revokeObjectURL(url);

                this.setState({
                    preLoader: false
                });
            } else {
                this.setState({
                    preLoader: false
                });
            }
        }).catch(error => {
            this.setState({
                alert_information: error.message,
                preLoader: false
            });
        });
    }

    render() {
        return (
            <Fragment>
                <div className="page_heading">
                    <h5>
                        {USAGE_LOG_LABELS.REPORT_USAGE_LOGS}
                    </h5>
                </div>
                <div>
                    <TatvamCol className="z-depth-2 centered mt-1 form-wrapper" s={12} m={12} l={12} xl={12}>
                        <Row>
                            <form className="multi_select_height">
                                <TatvamCol s={12} xl={12} className="formRow  mt-2">
                                    <TatvamCol m={2} xl={3} className="select-field">
                                        <label htmlFor="application">{USAGE_LOG_LABELS.CUSTOMER_CATEGORY}</label>
                                        <TatvamMultiSelect
                                            classNamePrefix="react-select"
                                            className={"validate"}
                                            value={this.state.selectedCategory}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            name={USAGE_LOG_LABELS.CUSTOMER_CATEGORY}
                                            id="category"
                                            onChange={this.handleCategoryChange}
                                            options={this.state.categoryListOption}
                                        />
                                    </TatvamCol>
                                    <TatvamCol m={2} xl={3} className="select-field">
                                        <label htmlFor="application">{USAGE_LOG_LABELS.APPLICATION}</label>
                                        <TatvamMultiSelect
                                            classNamePrefix="react-select"
                                            value={this.state.selectedApplication}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            name={USAGE_LOG_LABELS.APPLICATION}
                                            id="application"
                                            onChange={this.handleApplicationChange}
                                            options={this.state.applicationListOptions}
                                        />
                                    </TatvamCol>
                                    <TatvamCol m={2} xl={3} className="select-field">
                                        <label className="status-label">{USAGE_LOG_LABELS.START_DATE}</label>
                                        <TatvamDatePicker
                                            selected={new Date(this.state.startDate)}
                                            id="StartDate"
                                            maxDate={this.state.endDate && new Date(this.state.endDate)}
                                            onChange={this.handleStartDate}
                                            dateFormat={DATE_FORMAT.ddMMMyyy}
                                            placeholderText={DATE_FORMAT.DDMMMYYYY}
                                            showMonthDropdown
                                            showYearDropdown
                                            className="mt-4"
                                        />
                                    </TatvamCol>
                                    <TatvamCol m={2} xl={3} className="select-field">
                                        <label className="status-label">{USAGE_LOG_LABELS.END_DATE}</label>
                                        <TatvamDatePicker
                                            selected={new Date(this.state.endDate)}
                                            onChange={this.handleEndDate}
                                            minDate={this.state.startDate && new Date(this.state.startDate)}
                                            maxDate={new Date()}
                                            dateFormat={DATE_FORMAT.ddMMMyyy}
                                            validate
                                            placeholderText={DATE_FORMAT.DDMMMYYYY}
                                            showMonthDropdown
                                            showYearDropdown
                                            className="mt-4"
                                        />
                                    </TatvamCol>
                                </TatvamCol>
                                <TatvamCol s={12} xl={12} className="formRow  mt-2">
                                    <TatvamCol s={2} m={4} xl={3} className="switch-wrapper p-0">
                                        <Switch
                                            id={USAGE_LOG_PROPERTIES.IS_INCLUDE_INTERNAL_USERS}
                                            checked={this.state.is_include_internal_users}
                                            onChange={this.handleToggleChange}
                                            offLabel={USAGE_LOG_LABELS.INCLUDE_INTERNAL_USERS}
                                            m={2}
                                        />
                                    </TatvamCol>
                                    <TatvamCol s={2} m={4} xl={3} className="switch-wrapper p-0">
                                        <Switch
                                            id={USAGE_LOG_PROPERTIES.IS_INCLUDE_INACTIVE_CUSTOMERS}
                                            checked={this.state.is_include_inactive_customers}
                                            onChange={this.handleToggleChange}
                                            offLabel={USAGE_LOG_LABELS.INCLUDE_INACTIVE_CUSTOMERS}
                                            m={2}
                                        />
                                    </TatvamCol>
                                    {!this.state.isFormValid &&
                                        <p className="errorText col s12"> Please select minimun one category and
                                            application</p>}
                                    <TatvamCol s={2} m={4} xl={3}
                                        className="buttonWrapper right valign-wrapper formRow">
                                        <TatvamButton
                                            waves="light"
                                            className=" mt-1 mr-1 btn_primary  "
                                            onClick={this.handleSave}
                                            disabled={!this.state.editFlag}
                                        >
                                            {FORM_OPERATIONS.SUBMIT}
                                        </TatvamButton>
                                    </TatvamCol>
                                </TatvamCol>
                            </form>
                        </Row>
                        <Col
                            s={12}
                            className={this.state.preLoader ? "valign-wrapper loader-overlay" : "hide"}
                        >
                            {this.state.preLoader && <Loader type="ball-beat" />}
                        </Col>
                    </TatvamCol>
                </div>
                <div>
                    <TatvamCol xl={12} s={12} m={12} className="row mt-1 z-depth-4">
                        {this.state.exportData.length > 0 && (
                            <Fragment>
                                <CsvExport
                                    columns={this.state.exportColumns}
                                    datas={this.state.exportData}
                                    csvHeader={populateCsvHeader(
                                        false,
                                        false,
                                        true,
                                        this.state.startDate,
                                        this.state.endDate
                                    )}
                                    csvHeaderLineBreakCount={1}
                                    delimeter=","
                                    downloadFileName={`${USAGE_LOG_LABELS.REPORT_USAGE_LOGS}.csv`.split(' ').join('')}
                                />
                                <Col
                                    s={12}
                                    className={this.state.preLoader ? "valign-wrapper loader-overlay" : "hide"}
                                >
                                    {this.state.preLoader && <Loader type="ball-beat" />}
                                </Col>
                                <img
                                    onClick={this.handleDownloadHTML}
                                    className="table-html-icon"
                                    title="Download HTML"
                                    src={require("../../../../public/assets/images/html.jpg")}
                                    alt={"Download HTML"}>
                                </img>
                            </Fragment>
                        )}
                        <TatvamGrid
                            gridData={this.state.gridData}
                            colData={this.state.colDef}
                            enablePagination
                        />
                    </TatvamCol>
                </div>
                {this.state.isAlertBoxOpen && (
                    <AlertBox
                        open={this.state.isAlertBoxOpen}
                        isSuccess={this.state.isSuccess}
                        closeAlertBox={this.alterDiscard}
                        isConfirmBox={this.state.isConfirmBox}
                        alert_information={this.state.alert_information}
                    />
                )}
            </Fragment>
        );
    }
}

export default ReportUsageLogs;
